export const actionTypes = {
  // contact info (email, phones)
  SET_CONTACT_INFO_IS_LOADING: 'CONTACT_INFO/SET_CONTACT_INFO_IS_LOADING',
  GET_CONTACT_INFO: 'CONTACT_INFO/GET_CONTACT_INFO',
  CLEAR_CONTACT_INFO: 'CONTACT_INFO/CLEAR_CONTACT_INFO',
  SET_CONTACT_INFO_ERROR: 'CONTACT_INFO/SET_CONTACT_INFO_ERROR',
};
